import React from "react";
import { Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import { useLang } from "~/hooks/useLang";
import type { State } from "@hookstate/core";
import useDispatchState from "~/features/Dispatch/stores/DispatchState";

interface DialogOpenDispatchPopupLocationRequesterProps {
  readonly open: State<boolean>;
  readonly stationHasAccess: State<boolean>;
  readonly dispatchCode: string | null;
  readonly dispatchId: number | null;
}

export default function DialogOpenDispatchPopupLocationRequester({ open, stationHasAccess, dispatchCode, dispatchId }: DialogOpenDispatchPopupLocationRequesterProps) {
  const { translate } = useLang();
  const { syncDispatchFromId } = useDispatchState();

  const handleClose = () => {
    open.set(false);
  }

  const handleChangeDispatch = () => {
    handleClose()
    syncDispatchFromId(dispatchId)
  }

  return (
    <Dialog maxWidth={'xs'} fullWidth={true} open={open.get()} onClose={handleClose}>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {!stationHasAccess.get() ?
          <Typography variant='body2'>
            {translate('The station does not have access to the dispatch', { dispatch: dispatchCode })}
          </Typography> :
          dispatchCode && stationHasAccess.get() ? (
            <Typography variant='body2'>
              {translate('Do you want to open the dispatch', { dispatch: dispatchCode })}
            </Typography>
          ) : (
            false
          )}
      </DialogContent>
      <DialogActions>
        {!stationHasAccess.get() ?
          <Button variant="contained" onClick={handleClose}>
            {translate('Close')}
          </Button> :
          <>
            <Button variant="outlined" onClick={handleClose}>
              {translate('Cancel')}
            </Button>
            <Button
              disabled={!stationHasAccess.get()}
              variant="contained"
              onClick={handleChangeDispatch}>
              {translate('Yes')}
            </Button>
          </>
        }
      </DialogActions>
    </Dialog>
  )
}